"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Error = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function Error(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8.8 10.8C8.8 11.0209 8.62091 11.2 8.4 11.2H7.6C7.37909 11.2 7.2 11.0209 7.2 10.8V10C7.2 9.77909 7.37909 9.6 7.6 9.6H8.4C8.62091 9.6 8.8 9.77909 8.8 10V10.8ZM8.42412 8.00001C8.52584 8.00074 8.61191 7.925 8.62412 7.82401L8.94412 5.24801C8.95791 5.13389 8.92194 5.01934 8.84538 4.93359C8.76882 4.84784 8.65907 4.79918 8.54412 4.80001H7.45612C7.34116 4.79918 7.23141 4.84784 7.15485 4.93359C7.07829 5.01934 7.04232 5.13389 7.05612 5.24801L7.37612 7.82401C7.38832 7.925 7.47439 8.00074 7.57612 8.00001H8.42412Z",
    fill: "currentColor"
  }));
}

exports.Error = Error;